import React, { Fragment } from "react";
import _ from "lodash";
import { ActionTypes } from "../../../utils/types";
import IntlMessages from "../../../utils/messages";
import {
  Checkpoint,
  CheckpointType,
} from "../../../lib/ground-aws-graphql-core/models/Api/Inspection";
import CheckpointComponent from "../../Tailwind/Checkpoint";

interface Props {
  checkpointType: CheckpointType;
  items: {
    checkpointType: CheckpointType;
    checkpoint: Checkpoint;
    action: ActionTypes;
  }[];
  onRemoveCheckpoint: (t: CheckpointType, a: Checkpoint) => void;
}

const ListCheckpoints = (props: Props): JSX.Element => {
  const { items, onRemoveCheckpoint, checkpointType } = props;

  const checkpoints = items.filter(
    e =>
      e.action !== ActionTypes.TO_DELETE &&
      checkpointType.id === e.checkpointType.id
  );
  const noCheckpoints = _.isEmpty(checkpoints);

  if (noCheckpoints) {
    return (
      <div className="flex justify-center sm:py-6 sm:px-6 px-2 py-2 bg-ground-white-200 rounded-b-10">
        <span className="text-12px text-ground-gray-100 italic">
          <IntlMessages id="page.inspection.selected.checkpoints.empty" />
        </span>
      </div>
    );
  }

  return (
    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:py-6 sm:px-6 px-2 py-2 bg-ground-white-200 rounded-b-10">
      {checkpoints.map((i, index) => {
        return (
          <Fragment key={index}>
            <CheckpointComponent
              checkpointType={checkpointType}
              checkpoint={i.checkpoint}
              onRemoveCheckpoint={onRemoveCheckpoint}
            />
          </Fragment>
        );
      })}
    </div>
  );
};

export default ListCheckpoints;
